<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Useful Links & Resources'"
          :subTitleText="'Looking for insights as to how to best position yourself to do business with the government? Need to know more about new and emerging cyber threats? Project Spectrum is proud to be a great resource on all those fronts, but we recognize that there are other strategic resources that can help you as you build out the security principles that govern your business. Here are some useful links and resources that can help you move forward!'"
        />
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- Blog Grid Section Start -->
    <section class="section p-0 mt-5 section-content">
      <div class="container">
        <div class="pb-4">
          <b-form-input
            v-model="searchQuery"
            placeholder="Search Links and Resources..."
          ></b-form-input>
        </div>
        <p class="pb-2" v-if="displayedBlogItems.length === 0 && searchQuery">
          No items match the search criteria...
        </p>
        <p class="pb-2" v-if="displayedBlogItems.length === 0 && !searchQuery">
          Check back soon for blog posts...
        </p>
        <div class="blog-post-grid">
          <div class="row">
            <!-- Start Blog Item -->
            <div
              class="col-12 mb-3"
              v-for="item in displayedBlogItems"
              :key="item.id"
            >
              <div class="row blog-item border d-flex">
                <!-- TODO: TEMPORARILY COMMENTED OUT THE USEFUL LINKS IMGE BELOW UNTIL A REDISCOVERY IS DONE -->
                <!-- <a 
                  class="col-4 col-lg-2 col-xl-2 blog-post-image center-image-vertically"
                  :href="item.url"
                  target="_blank"
                >
                  <img
                    :src="item.thumbnail"
                    :alt="item.thumbnailDescription"
                    class="cover"
                  />
                </a> -->
                <div class="col-12 p-3 useful-link-info">
                  <a class="text-dark">
                    <div
                      class="post-event d-inline-block align-items-center pt-2"
                    >
                      <a class="blog-info-meta text-dark">{{
                        item.taggedCategory[0]?.text.toUpperCase()
                      }}</a>
                    </div>
                    <h4 class="blog-post-title mt-1">
                      {{ item.title }}
                    </h4>
                    <p class="limit-lines-3">{{ item.description }}</p>
                    <a class="limit-lines-1" :href="item.url" target="_blank">{{
                      item.url
                    }}</a>
                  </a>
                </div>
                <!-- <a class="blog-read-more" :href="item.url" target="_blank">
                                            <i class="mdi mdi-arrow-right"></i>
                                        </a>                                    -->
              </div>
            </div>
            <!-- End Blog Item -->
          </div>
        </div>
        <div>
          <b-pagination
            id="blog-pagination"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            @page-click="pageClicked"
          ></b-pagination>
        </div>
      </div>
    </section>
    <!-- Blog Grid Section End -->
  </div>
</template>
<script>
import axios from 'axios';
import { BPagination, BFormInput } from 'bootstrap-vue';
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
import TitleTextContent from '../library/widgets/title-text-content.vue';
export default {
  name: 'blog',
  components: {
    BPagination,
    BFormInput,
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  props: {
    query: String,
  },
  data() {
    return {
      searchQuery: this.query,
      items: [],
      itemCount: 0,
      currentPage: 1,
      perPage: 6,
    };
  },
  computed: {
    blogItemsFromSearchQuery() {
      if (this.searchQuery) {
        return this.items.filter((item) => {
          return this.searchQuery
            .toLowerCase()
            .split(' ')
            .every(
              (v) =>
                item.title.toLowerCase().includes(v) ||
                item.description.toLowerCase().includes(v) ||
                item.thumbnailDescription.toLowerCase().includes(v) ||
                item.url.toLowerCase().includes(v)
            );
        });
      } else {
        return this.items;
      }
    },
    displayedBlogItems() {
      return this.blogItemsFromSearchQuery.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    totalRows() {
      return this.blogItemsFromSearchQuery.length;
    },
  },
  mounted: async function () {
    this.init();
    this.getItems(); // async
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
    async getItems() {
      /*  API call to server: GET /api/resources/usefulLinks  */
      axios
        .get('/api/resources/usefulLinks')
        .then((response) => {
          this.items = response.data.Items.filter((item) => !item.title.toLowerCase().includes('aptac')); // 'APTAC' TITLE HAS BEEN ASKED TO BE REMOVED FROM AMONG THE LIST OF USEFUL LINKS
          this.itemCount = response.data.Count;
          //console.log(this.items);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    pageClicked() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>
<style scoped>
#blog-pagination li {
  margin: 0px;
}
.useful-link-info {
  padding: 10px 5px 25px 0;
}

.cover {
  object-fit: cover;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
  padding: 10px;
}
.center-image-vertically {
  display: flex;
  justify-content: center;
}
</style>
